import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import "../styles/verificationpopup.css"

const VerificatonPopUp = ({ account, canc, setCanc }) => {

  return (
    <>
      <div className="verifPopUp">
        <div className="verifContainer">
          <h3>Important</h3>
          <p>Your are currently on Demo Version. Please complete the verification process to upgrade your account. Once verified, you can enjoy our services without interruption/delay. </p>
          <Link to={`/${account?.userName}/verify-my-account`}>Apply For Verification</Link>
          <h5 onClick={(e) => { setCanc(false) }}>Show Me Later</h5>
        </div>
      </div>
    </>
  )
}

export default VerificatonPopUp